import React from "react";
import { Link } from "react-router-dom";

import TallCard from "../TallCard";
import ProjectsList from './ProjectsList.json';

const ProjectsRow = ({ handles = [] }) => {
    const selectedProjects = ProjectsList.filter(project => handles.includes(project.handle));

    return (
        <>
            <section className="projects">
                <div className="container">
                    <p className="section-title">Projects</p>
                    <div className="grid">
                        {selectedProjects.map(({handle, title, desc, stack, image}, index) => {
                            return (
                                <Link to={`/project/${handle}`} key={index}>
                                    <TallCard title={title} desc={desc} stack={stack} image={image} />
                                </Link>
                            );
                        })}
                    </div>
                    <Link to={"/projects"}><p class="muted-btn">View All Projects <i className="fas fa-chevron-right"></i></p></Link>
                </div>
            </section>
        </>
    );
};

export default ProjectsRow;